export { decodeCbor } from "./decoder.ts";
export { encodeCbor } from "./encoder.ts";
export {
	CborError,
	type CborOptions,
	DEFAULT_MAX_CBOR_BYTE_LENGTH,
	DEFAULT_MAX_CBOR_CONTAINER_LENGTH,
	DEFAULT_MAX_CBOR_DEPTH,
} from "./options.ts";
